'use strict';

angular.module('selfAccessRequestControllers')

    .controller('ArrivalOtherNeedsController',
                ['$scope', '$q', '$state', 'topBar', '$modal', '$stateParams', '$timeout', '$translate', 'selfAccessRequestService', 'selfAccessRequest', 'searchService', 'processStep', 'decisionLookUpsById',
        function ($scope, $q, $state, topBar, $modal, $stateParams, $timeout, $translate, selfAccessRequestService, selfAccessRequest, searchService, processStep, decisionLookUpsById) {

            // Variables
            var requestTimeout;

            // Scope Variables
            $scope.followUp = {};
            $scope.processStep = processStep;

            //Top Bar
            $translate('iam.selfAccessRequest.arrival.specialNeeds.pageTitle').then(function(translation) {
                topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                        '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-pencil-square-o');
            });

            selfAccessRequestService
              .getSpecialNeedsFollowup($stateParams.userAccessRequestId)
              .then(function (followUp) {
                  if (!_.isEmpty(followUp)) {
                      $scope.followUp = followUp;
              }
            });

            $scope.completeSpecialNeeds = function () {
                selfAccessRequestService
                   .createOrUpdateSpecialNeedsFollowup($stateParams.userAccessRequestId, $scope.followUp)
                   .then(function (selfAccessRequest) {
                       selfAccessRequestService
                        .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'SpecialNeeds')
                        .then(function (selfAccessRequest) {
                            $state.go(selfAccessRequest.SelfRequestPageRoute, {}, {reload:true});

                        });
                   });

            }
        }
    ]);